import { graphql } from 'gatsby';
import React from 'react';

import { PrimaryLink } from '../components/Common/Links';
import AgendaHeading from '../components/Generic/AgendaHeading';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import * as styles from './sparkLocation.module.css';

const SparkLocation = ({ data, location }) => {
  const locationPageContent = {
    HeaderContent: {
      pageTitle: 'Location',
      pageSubHeader:
        'The Omni CNN Center is only a short drive from the Hartsfield-Jackson Airport and easily accessible via MARTA, Atlanta’s public transportation.',
      backgroundImageUrl:
        'https://images.ctfassets.net/dkgr2j75jrom/6AtALxZYWCCkOqmuiPYQRU/0a78ed96b2ce3446f31350d2a2b74e1a/Mask_group__10_.jpg',
    },
    LocationDetails: {
      locationName: 'Omni Atlanta Hotel at CNN Center',
      paymentRate: '$199/night ',
      Address: '220 Marietta St NW, Atlanta, GA 30303',
      venue: 'Spark Venue',
      illustrationImgUrl: '/images/OmniHotel.jpg',
    },
    OtherLocations: [
      {
        locationName: 'Embassy Suites by Hilton',
        Address: '267 Marietta Street, Atlanta, GA, 30313',
        venue: '0.2 mile from venue',
      },
      {
        locationName: 'Glenn Hotel, Autograph',
        Address: '110 Marietta St NW, Atlanta, GA 30303',
        venue: '0.1 mile from venue',
      },
      {
        locationName: 'The Ritz-Carlton Atlanta',
        Address: '181 Peachtree Street, N.E,  Atlanta, GA 30303',
        venue: '0.5 mile from venue',
      },
    ],
  };

  return (
    <Layout isSpark pageMeta={data?.page?.pageMetaData}>
      <MarketingSeo meta={data?.page?.pageMetaData} slug={location.pathname} />
      <div>
        <AgendaHeading page={data?.page} />
        <LocationDetails locationDetails={locationPageContent.LocationDetails} />
        {/*TODO: Display this section when Omni is 70% booked */}
        {/*<OtherLocations otherLocations={locationPageContent.OtherLocations} />*/}
      </div>
    </Layout>
  );
};

const LocationDetails = ({ locationDetails }) => {
  return (
    <div className={styles.locationDetailsContentContainer}>
      <div className={styles.divisionOne}>
        <h2 className={styles.locationName}>{locationDetails.locationName}</h2>
        <div>
          <div>
            <p className={styles.paymentRate}>{locationDetails.paymentRate}</p>
            <p className={styles.discountText}>*discounted rate</p>
          </div>
          <p className={styles.Address}>{locationDetails.Address}</p>
          <p className={styles.venue}>
            <span className={styles.pin}>📍</span>
            {locationDetails.venue}
          </p>
        </div>
        <br />
        {/* <PrimaryLink
          backgroundColor="pink"
          isButton
          className={styles.bookButtonStyles}
          url="https://www.omnihotels.com/hotels/atlanta-cnn-center/meetings/fullstory-user-conference-10022022"
          label="Book now"
        /> */}
        <p>Book before September 30 at 5pm ET to secure your Spark discount.</p>
        <p>
          There’s plenty to enjoy in and around downtown Atlanta between Spark sessions, including:
          <ul>
            <li>The SkyView Ferris wheel at Centennial Olympic Park</li>
            <li>The Georgia Aquarium</li>
            <li>The World of Coca-Cola</li>
            <li>The historic Sweet Auburn district</li>
          </ul>
        </p>
      </div>
      <div className={styles.divisionTwo}>
        <div className={styles.IllustrationImg}>
          <img src={locationDetails.illustrationImgUrl} alt="Omni Hotel in Atlanta" />
        </div>
      </div>
      {/* <button className={styles.bookButtonStylesMobile}>BOOK NOW</button> */}
    </div>
  );
};
// eslint-disable-next-line no-unused-vars
const OtherLocations = ({ otherLocations }) => {
  return (
    <div className={styles.OtherLocationsContentContainer}>
      {otherLocations.map((location) => (
        <div className={styles.locationCardContainer}>
          <h3 className={styles.locationName}>{location.locationName}</h3>
          <p className={styles.Address}>{location.Address}</p>
          <p className={styles.venue}>{location.venue}</p>
        </div>
      ))}
    </div>
  );
};

export default SparkLocation;

export const query = graphql`
  query SparkLocationQuery($slug: String!) {
    page: contentfulMultipurposePageTemplate(slug: { eq: $slug }) {
      ...MultipurposePage
    }
  }
`;
